import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface UpdateBusinessRegNoRequest {
  businessRegNo: string;
}

/**
 * 법인카드 연결 사업자번호 수정 API
 * @param companyId 회사 ID
 * @param connectionId 연결 ID
 * @param businessRegNo 사업자번호
 */
export function updateCorporateCardBusinessRegNo(
  companyId: string,
  connectionId: number,
  businessRegNo: string,
) {
  return API.patch<ResponseBase>(
    `/api/v2/companies/${companyId}/corporate-cards/connection/${connectionId}/business-reg-no`,
    { data: { businessRegNo } },
  );
}
